import env from '../../env';
import { AppClientId } from '../Shared/constants';
import * as installationConstants1 from './installations/1/constants';
import * as installationConstants2 from './installations/2/constants';
import * as installationConstants3 from './installations/3/constants';
import * as installationConstants4 from './installations/4/constants';
import * as installationConstants6 from './installations/6/constants';
import * as installationConstants7 from './installations/7/constants';

let installationConstants;
switch (env.clientId) {
  case AppClientId.INDEWAL:
    installationConstants = installationConstants1;
    break;
    case AppClientId.IDWLEASE:
      installationConstants = installationConstants1;
      break;
  case AppClientId.HARRY_NIJBOER:
    installationConstants = installationConstants2;
    break;
  case AppClientId.HOOIKAMMER:
    installationConstants = installationConstants3;
    break;
  case AppClientId.IDW_GMBH:
    installationConstants = installationConstants4;
    break;
  case AppClientId.AUTOWIENTJES:
    installationConstants = installationConstants6;
    break;
  case AppClientId.AUTOHUISSALLAND:
    installationConstants = installationConstants7;
    break;
  default:
    installationConstants = installationConstants1;
}

export const KANBANBOARDS_DOMAIN = 'app/modules/Contents/KANBANBOARDS_DOMAIN';
export const REQUEST_KANBAN_BOARDS = 'app/modules/Contents/REQUEST_KANBAN_BOARDS';
export const GET_KANBAN_BOARDS = 'app/modules/Contents/GET_KANBAN_BOARDS';
export const REQUEST_KANBAN_BOARD = 'app/modules/Contents/REQUEST_KANBAN_BOARD';
export const REQUEST_KANBAN_BOARD_COLUMN_CELLS = 'app/modules/Contents/REQUEST_KANBAN_BOARD_COLUMN_CELLS';
export const REQUEST_KANBAN_BOARD_COLUMN_CELLS_CACHE_REFRESH =
  'app/modules/Contents/REQUEST_KANBAN_BOARD_COLUMN_CELLS_CACHE_REFRESH';
export const REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK = 'app/modules/Contents/REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK';
export const REQUEST_KANBAN_BOARD_PERFORM_ACTION = 'app/modules/Contents/REQUEST_KANBAN_BOARD_PERFORM_ACTION';
export const REQUEST_KANBAN_BOARD_COLUMN_OPERATION = 'app/modules/Contents/REQUEST_KANBAN_BOARD_COLUMN_OPERATION';

export const KANBAN_BOARDS_REFRESH = 'app/modules/Contents/KANBAN_BOARDS_REFRESH';
export const KANBAN_BOARDS_SET_ACTIVE_BOARD = 'app/modules/Contents/KANBAN_BOARDS_SET_ACTIVE_BOARD';
export const PREPARE_KANBAN_PROGRESS_BAR = 'app/modules/Contents/PREPARE_KANBAN_PROGRESS_BAR';
export const SET_KANBAN_PROGRESS_BAR_VALUE = 'app/modules/Contents/SET_KANBAN_PROGRESS_BAR_VALUE';

export const REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS = 'app/modules/Contents/REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS';

export const REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_FROM_CACHE =
  'app/modules/Contents/REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_FROM_CACHE';

export const REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD =
  'app/modules/Contents/REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD';

export const REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_NEXT =
  'app/modules/Contents/REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_NEXT';

export const REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVATE =
  'app/modules/Contents/REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVATE';

export const REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE =
  'app/modules/Contents/REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE';

export const REQUEST_CACHE_STATUS = 'app/modules/Contents/REQUEST_CACHE_STATUS';

export const TASK_STATUS_INACTIVE = '0';
export const TASK_STATUS_ACTIVE = '1';
export const TASK_STATUS_PLAN = '2';
export const TASK_STATUS_PLANNED = '3';

export const TOGGLE_KANBAN_COMPANY_MODAL = 'app/modules/Contents/TOGGLE_KANBAN_COMPANY_MODAL';

export const RESET_ALL_KANBAN_FILTERS = 'app/modules/Contents/RESET_ALL_KANBAN_FILTERS';
export const RESET_KANBAN_FILTER = 'app/modules/Contents/RESET_KANBAN_FILTER';
export const APPLY_KANBAN_FILTERS = 'app/modules/Contents/APPLY_KANBAN_FILTERS';
export const SET_KANBAN_COLUMN_SORT = 'app/modules/Contents/SET_KANBAN_COLUMN_SORT';
export const UPDATE_KANBAN_FILTERS = 'app/modules/Contents/UPDATE_KANBAN_FILTERS';


export const EXTERIOR_ATTENTION_OPTIONS_IDW = {
  parts: [
  'linksvoor',
  'spatbord_linksvoor',
  'wiel_linksvoor',
  'spiegel_links',
  'voorzijde',
  'bumper_voor',
  'koplamp_links',
  'koplamp_rechts',
  'grille',
  'motorkap',
  'voorruit',
  'dorpel_rechts',
  'rechtsvoor',
  'spatbord_rechtsvoor',
  'wiel_rechtsvoor',
  'spiegel_rechts',
  'deur_rechtsvoor',
  'rechter_dakstijl',
  'deur_rechtsachter',
  'rechtsachter',
  'spatbord_rechtsachter',
  'wiel_rechtsachter',
  'schuifdeur_rechts',
  'bumper_achter',
  'achterlicht_rechts',
  'achterlicht_links',
  'achterzijde',
  'kofferklep',
  'achterruit',
  'deur_achter',
  'laaddeur_rechtsachter',
  'laaddeur_linksachter',
  'linksachter',
  'spatbord_linksachter',
  'wiel_linksachter',
  'deur_linksachter',
  'linker_dakstijl',
  'schuifdeur_links',
  'dorpel_links',
  'deur_linksvoor',
  'dak',
  'panoramadak',
  'rondom',
  'anders',
  'Accesoires',

  ],
  types: ['barst', 'breuk', 'defect', 'deuk', 'deukje(s)', 'eerder_herstel', 'hagelschade', 'kras', 'krassen', 'krasje', 'ontzet', 'roest', 'ster', 'steenslag', 'sticker', 'verweerd', 'anders', 'accesoires'],

  solutions: [
    'Herstellen_spuiten',
    'Inlakken',
    'Kunststof_reparatie',
    'Plaatwerk',
    'Polijsten',
    'Restyle',
    'Restyle_polijsten',
    'Ruitreparatie',
    'Spuiten',
    'Spotrepair',
    'Vervangen',
    'Velgreparatie',
    'Anders',
  ],
  





};

export const INTERIOR_ATTENTION_OPTIONS_IDW = {
  parts: [
    'achterbank',
    'bekleding',
    'dashboard',
    'hemelbekleding',
    'laadruimte',
    'manco',
    'stoel_achter',
    'stoel_linksvoor',
    'stoel_rechtsvoor',
    'anders',

  ],
  types: [
    'brandgaatje',
    'gebruikssporen',
    'gebroken',
    'kras',
    'scheur_or_kras',
    'slijtage',
    'vlek',
    'anders',
    'accesoires',
  ],
  solutions: [
    'diverse',
    'kunststof_reparatie',
    'reparatie',
    'vervangen',
    'anders',
  ],
};

export const TECHNICAL_ATTENTION_OPTIONS_IDW = {
  parts: ['lekkage', 'geluid', 'servicemelding', 'motormanagement', 'anders'],
  types: ['-'],
  solutions: ['diagnose_stellen', 'onderhoud_uitvoeren'],
};

export const EXTERIOR_ATTENTION_OPTIONS = {
  parts: [
  'linksvoor',
  'spatbord_linksvoor',
  'wiel_linksvoor',
  'spiegel_links',
  'voorzijde',
  'bumper_voor',
  'koplamp_links',
  'koplamp_rechts',
  'grille',
  'motorkap',
  'voorruit',
  'dorpel_rechts',
  'rechtsvoor',
  'spatbord_rechtsvoor',
  'wiel_rechtsvoor',
  'spiegel_rechts',
  'deur_rechtsvoor',
  'rechter_dakstijl',
  'deur_rechtsachter',
  'rechtsachter',
  'spatbord_rechtsachter',
  'wiel_rechtsachter',
  'schuifdeur_rechts',
  'bumper_achter',
  'achterlicht_rechts',
  'achterlicht_links',
  'achterzijde',
  'kofferklep',
  'achterruit',
  'deur_achter',
  'laaddeur_rechtsachter',
  'laaddeur_linksachter',
  'linksachter',
  'spatbord_linksachter',
  'wiel_linksachter',
  'deur_linksachter',
  'linker_dakstijl',
  'schuifdeur_links',
  'dorpel_links',
  'deur_linksvoor',
  'dak',
  'panoramadak',
  'rondom',
  'anders',

  ],
  types: ['barst', 'breuk', 'deuk', 'deukje(s)', 'eerder_herstel', 'hagelschade', 'kras', 'krassen', 'krasje', 'roest', 'ster', 'steenslag', 'sticker', 'anders'],

  solutions: [
    'Herstellen_spuiten',
    'Inlakken',
    'Kunststof_reparatie',
    'Plaatwerk',
    'Polijsten',
    'Restyle',
    'Restyle_polijsten',
    'Ruitreparatie',
    'Spuiten',
    'Spotrepair',
    'Vervangen',
    'Velgreparatie',
    'Anders',
  ],
  





};

export const INTERIOR_ATTENTION_OPTIONS = {
  parts: [
    'achterbank',
    'bekleding',
    'dashboard',
    'hemelbekleding',
    'laadruimte',
    'manco',
    'stoel_achter',
    'stoel_linksvoor',
    'stoel_rechtsvoor',
    'anders',
  ],
  types: [
    'brandgaatje',
    'rooklucht',
    'gebruikssporen',
    'gebroken',
    'kras',
    'scheur_or_kras',
    'slijtage',
    'vlek',
    'gerookt',
    'overmatig_vervuild',
    'anders',
  ],
  solutions: [
    'diverse',
    'kunststof_reparatie',
    'reparatie',
    'vervangen',
    'anders',
  ],
};

export const TECHNICAL_ATTENTION_OPTIONS = {
  parts: ['lekkage', 'geluid', 'servicemelding', 'motormanagement',  'diverse storingen', 'anders'],
  types: ['-'],
  solutions: ['diagnose_stellen', 'onderhoud_uitvoeren'],
};

export const BUYERS_OPTIONS = installationConstants.BUYERS_OPTIONS;

export const PLANNABLE_STATUS_OPTIONS = [
  {
    label: 'Taak afgerond',
    value: 0,
  },
  {
    label: 'Taak plannen',
    value: 1,
  },
  {
    label: 'Intern uitvoeren',
    value: 2,
  },
  {
    label: 'Extern uitvoeren',
    value: 3,
  },
];

export const VEHICLE_STATUS_OPTIONS = [
  {
    label: 'To sell',
    value: 0,
  },
  {
    label: 'Consignment',
    value: 1,
  },
  {
    label: 'Reserved',
    value: 2,
  },
  {
    label: 'Sold',
    value: 3,
  },
  {
    label: 'Blocked',
    value: 4,
  },
  {
    label: 'Credited',
    value: 5,
  },
  {
    label: 'Deleted',
    value: 6,
  },
];

export const COMPANY_LOCATION_OPTIONS = [
  { value: 4, label: 'Home' },
  { value: 'other', label: 'Away' },
];
